// Studyo Today Backend
// Package studyo.today.classroom.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/classroom/v1/resources/sync_school_subject.proto (package studyo.today.classroom.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/classroom/v1/resources/sync_school_subject.proto.
 */
export const file_studyo_today_classroom_v1_resources_sync_school_subject = /*@__PURE__*/
  fileDesc("Cj1zdHVkeW8vdG9kYXkvY2xhc3Nyb29tL3YxL3Jlc291cmNlcy9zeW5jX3NjaG9vbF9zdWJqZWN0LnByb3RvEiNzdHVkeW8udG9kYXkuY2xhc3Nyb29tLnYxLnJlc291cmNlcyI6ChFTeW5jU2Nob29sU3ViamVjdBISCgpwbGFubmVyX2lkGAEgASgJEhEKCXNjaG9vbF9pZBgCIAEoCUIrqgIoU3R1ZHlvLlRvZGF5LkNsYXNzcm9vbS5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the message studyo.today.classroom.v1.resources.SyncSchoolSubject.
 * Use `create(SyncSchoolSubjectSchema)` to create a new message.
 */
export const SyncSchoolSubjectSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_classroom_v1_resources_sync_school_subject, 0);

